module.exports = new __parcel__URL__("x-check.fcf77d4b.svg").toString();